<script>
  import { fade } from "svelte/transition";
  import { onMount, beforeUpdate } from "svelte";
  import ColorShade from "./ColorShade.svelte";
  import chroma from "chroma-js";
  let _groupData = [];
  export let groupColor = "";

  //   const generateGroup = () => {
  //      };
  const buildColorShade = (color) => {
    const rgb = chroma(color).rgba();
    const step = 16,
      maxCount = 9,
      limit = maxCount * step;
    let r = rgb[0],
      g = rgb[1],
      b = rgb[2],
      a = parseInt(rgb[3] === undefined ? 0 : rgb[3]);
    let tempR = r,
      tempG = g,
      temB = b;
    let brightArr = [],
      darkArr = [];
    let counter = 0;
    //genrate bright array
    let trackCounter = 0,
      trackColor;
    while (r <= 255 && g <= 255 && b <= 255 && counter < limit) {
      r += step;
      g += step;
      b += step;
      let colrgba = chroma(r, g, b, a),
        colrgb = chroma(r, g, b);
      if (chroma.valid(colrgba)) brightArr.push(colrgba.hex());
      else brightArr.push(colrgb.hex());
      // console.log(
      //   `counter = ${counter} , color (BRIGHT) = ${brightArr[counter]}`
      // );
      trackColor = brightArr[trackCounter];
      if (trackCounter > 0 && brightArr[brightArr.length - 2] === trackColor) {
        brightArr.pop();
        break;
      }
      trackCounter++;
      counter += step;
    }
    //generate dark array
    //reset r g b values
    r = tempR;
    g = tempG;
    b = temB;
    counter = 0;
    trackCounter = 0;
    while (r <= 255 && g <= 255 && b <= 255 && counter < limit) {
      r -= step;
      g -= step;
      b -= step;
      let colrgba = chroma(r, g, b, a),
        colrgb = chroma(r, g, b);
      if (chroma.valid(colrgba)) darkArr.push(colrgba.hex());
      else darkArr.push(colrgb.hex());
      // console.log(`counter = ${counter} , color (DARK) = ${darkArr[counter]}`);
      trackColor = darkArr[trackCounter];
      if (trackCounter > 0 && darkArr[darkArr.length - 2] === trackColor) {
        darkArr.pop();
        break;
      }
      trackCounter++;
      counter += step;
    }

    //fill _groupdata
    let i;
    for (i = darkArr.length - 1; i >= 0; i--) _groupData.push(darkArr[i]);
    _groupData.push(groupColor);
    for (i = 0; i < brightArr.length; i++) _groupData.push(brightArr[i]);

    console.log("DDD", darkArr, "BBB", brightArr, "FULL", _groupData);
    // return  + 2* + 3*+ 4*();
  };
  beforeUpdate(() => {
    let i,
      start = 7,
      step = 1,
      end = start + 1;
    buildColorShade(groupColor);
    // for (i = start; i > 0; i -= step)
    // let brightStart = chroma(groupColor).brighten(start).hex();
    // let darkEnd = chroma(groupColor).darken(end).hex();
    // for (i = start; i > 0; i -= step)
    //   _groupData.push(chroma(groupColor).brighten(i).hex());
    // _groupData.push(chroma(groupColor).hex());
    // for (i = step; i <= end; i += step)
    //   _groupData.push(chroma(groupColor).darken(i).hex());
  });
</script>

<!-- <div id="palette"> -->
<div class="palette-shade">
  {#each _groupData as gd}
    {#if gd.toUpperCase() === chroma(groupColor).hex().toUpperCase()}
      <div class="hilite">
        <ColorShade color={gd} />
      </div>
    {:else}
      <ColorShade color={gd} />
    {/if}
  {/each}
</div>

<!-- </div> -->
<style>
  .palette-shade {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    /* justify-content: center; */
  }
  .hilite {
    border: 4px double rgb(240, 157, 4);
    margin: 4px;
  }
</style>
